module.exports = {
	"data": [
		{
			"name": "Folder1",
			"subFolders": [
				{
					"name": "Sub1"
				},
				{
					"name": "Sub2"
				}
			]
		},
		{
			"name": "Folder1",
			"subFolders": [
				{
					"name": "Sub1"
				},
				{
					"name": "Sub2"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 298
// module chunks = 0